const parseBoolean = (str = '') => str.toLowerCase() === 'true';

// Environment
export const ENABLE_MOCKS = parseBoolean(
  import.meta.env.REACT_APP_ENABLE_MOCKS
);

export const IS_TEST = parseBoolean(import.meta.env.REACT_APP_IS_TEST);

const config = {
  //Auth0
  audience: import.meta.env.REACT_APP_AUTH0_AUDIENCE || '',
  clientId: import.meta.env.REACT_APP_AUTH0_CLIENT_ID || '',
  connection: 'Username-Password-Authentication',
  domain: import.meta.env.REACT_APP_AUTH0_DOMAIN || '',
  namespace: `${import.meta.env.REACT_APP_AUTH0_DOMAIN}/`,
  scope: 'openid profile email',
  claimsNamespace: 'https://myid.resideo.com',
  oauthTokenEndpoint: import.meta.env.REACT_APP_AUTH0_OATH_TOKEN_ENDPOINT || '',
};

export const PRO_PORTAL_URL = import.meta.env.REACT_APP_PRO_PORTAL_URL || '';
export const PRO_PORTAL_ACCEPT_INVITE_PATH =
  import.meta.env.REACT_APP_PRO_PORTAL_ACCEPT_INVITE_PATH || '';
export const FIRST_ALERT_LOGIN_CALLBACK_PATH =
  import.meta.env.REACT_APP_FIRST_ALERT_LOGIN_CALLBACK_PATH || '';

export const STATUS_PAGE_URL = import.meta.env.REACT_APP_STATUS_PAGE_URL || '';

// Sentry
export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN || '';
export const ENVIRONMENT =
  import.meta.env.REACT_APP_ENVIRONMENT || 'development';
export const SENTRY_SAMPLE_RATE = parseFloat(
  import.meta.env.REACT_APP_SENTRY_SAMPLE_RATE || '0.2'
);
export const SENTRY_ENABLE_LOCALHOST = parseBoolean(
  import.meta.env.REACT_APP_SENTRY_ENABLE_LOCALHOST
);

export const GOOGLE_MAPS_API_KEY =
  import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const RECAPTCHA_SITE_KEY =
  import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export const LOGIN_CUSTOM_ENDPOINTS = [
  import.meta.env.REACT_APP_LOGIN_URL_CONSUMER_ECOMMERCE || '',
  import.meta.env.REACT_APP_LOGIN_URL_RESIDEO_ACADEMY || '',
];

export const SHOPIFY_STORE_LOGIN_URL =
  import.meta.env.REACT_APP_SHOPIFY_STORE_LOGIN_URL || '';

export const RESIDEO_ACADEMY_RETURN_TO_URL =
  import.meta.env.REACT_APP_RESIDEO_ACADEMY_RETURN_TO_URL || '';

export const CONSUMER_TERMS_URL =
  import.meta.env.REACT_APP_CONSUMER_TERMS_URL || '';
export const CONSUMER_EULA_URL =
  import.meta.env.REACT_APP_CONSUMER_EULA_URL || '';
export const PRIVACY_POLICY_URL =
  import.meta.env.REACT_APP_PRIVACY_POLICY_URL || '';
export const PRO_TERMS_NA_URL =
  import.meta.env.REACT_APP_PRO_TERMS_NA_URL || '';
export const PRO_TERMS_EMEA_URL =
  import.meta.env.REACT_APP_PRO_TERMS_EMEA_URL || '';
export const PARTNER_PRO_TERMS_EMEA_URL =
  import.meta.env.REACT_APP_PARTNER_PRO_TERMS_EMEA_URL || '';
export const CONSUMER_TERMS_EMEA_URL =
  import.meta.env.REACT_APP_CONSUMER_TERMS_EMEA_URL || '';
export const PRIVACY_POLICY_URL_MIDDLE_EAST =
  import.meta.env.REACT_APP_PRIVACY_POLICY_MIDDLE_EAST_URL || '';

export const CONSUMER_TERMS_SUPPORTED_LANGUAGES =
  import.meta.env.REACT_APP_CONSUMER_TERMS_SUPPORTED_LANGUAGES || '';
export const CONSUMER_EULA_SUPPORTED_LANGUAGES =
  import.meta.env.REACT_APP_CONSUMER_EULA_SUPPORTED_LANGUAGES || '';
export const PRO_TERMS_NA_SUPPORTED_LANGUAGES =
  import.meta.env.REACT_APP_PRO_TERMS_NA_SUPPORTED_LANGUAGES || '';
export const PRO_TERMS_EMEA_SUPPORTED_LANGUAGES =
  import.meta.env.REACT_APP_PRO_TERMS_EMEA_SUPPORTED_LANGUAGES || '';
export const MIDDLE_EAST_COUNTRIES = import.meta.env
  .REACT_APP_MIDDLE_EAST_COUNTRIES;

export const RIS_BASE_URL = import.meta.env.REACT_APP_RIS_BASE_URL || '';
export const PRO_TERMS_US_CA_URL =
  import.meta.env.REACT_APP_PRO_TERMS_US_CA_URL || '';
export const PERK_TERMS_US_CA_URL =
  import.meta.env.REACT_APP_PERK_TERMS_US_CA_URL || '';
export const PRO_TERMS_GB_URL =
  import.meta.env.REACT_APP_PRO_TERMS_GB_URL || '';
export const PERK_TERMS_GB_URL =
  import.meta.env.REACT_APP_PERK_TERMS_GB_URL || '';

export const FIRST_ALERT_URL = import.meta.env.REACT_APP_FIRST_ALERT_URL || '';
export const HONEYWELL_HOME_URL =
  import.meta.env.REACT_APP_HONEYWELL_HOME_URL || '';
export const PRO_PORTAL_LINK_URL =
  import.meta.env.REACT_APP_PRO_PORTAL_LINK_URL || '';
export const RESIDEO_ACADEMY_LINK_URL =
  import.meta.env.REACT_APP_RESIDEO_ACADEMY_LINK_URL || '';
export const ALARMNET_360_URL =
  import.meta.env.REACT_APP_ALARMNET_360_URL || '';
export const PRO_PERKS_URL = import.meta.env.REACT_APP_PRO_PERKS_URL || '';

export const STACK_IDENTIFIER =
  import.meta.env.REACT_APP_STACK_IDENTIFIER || 'RIQ';

export default config;
